/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { Col, Row, Typography } from 'antd';
import routes from '@/utils/routes';
import KognitosIcon from '@/components/icons/KognitosIcon';
import { Link } from 'react-router-dom';
import Container from '@/components/Container';
import classnames from 'classnames';
import styles from './UnauthorizedPageLayout.module.less';

function UnauthorizedPageLayout(props: any) {
  return (
    <div className={styles.pageContainer}>
      <img
        src="https://www.kognitos.com/wp-content/themes/kognitos/assets/img/home-bg.png"
        className={styles.backgroundImage1}
        alt=""
      />
      <img
        src="https://www.kognitos.com/wp-content/themes/kognitos/assets/img/home-bg.png"
        className={styles.backgroundImage2}
        alt=""
      />
      <Container>
        <Row gutter={16}>
          <Col sm={24} md={12}>
            <div className={styles.imageContainer}>
              <Link
                to={routes.global.getHomePageUrl()}
                className={classnames('display-flex', styles.logo)}
              >
                <div className="app-logo" data-cy="nav-home">
                  <KognitosIcon />
                </div>
              </Link>
              <div className={styles.titleContainer}>
                <Typography.Title level={2} className={styles.title}>
                  Start your business automation journey with us
                </Typography.Title>
                <br />
                <Typography.Text className={styles.subTitle}>
                  Build automations and manage exceptions all in intuitive
                  English
                </Typography.Text>
              </div>
            </div>
          </Col>
          <Col sm={24} md={12}>
            <div className={styles.rightContainer}>{props.children}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default UnauthorizedPageLayout;
